import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

// Types and initial state
//-------------------------
type ModalType = 'drawer' | 'modal' | 'submenu';

type ModalObject = {
  id: string;
  isVisible: boolean;
  type?: ModalType;
};
type ModalList = { [key: string]: ModalObject };

export interface ModalState {
  list: ModalList;
}

const initialState: ModalState = {
  list: {},
};

// REDUCERS
export const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    setModalState: (state, action: PayloadAction<ModalObject>) => {
      state.list[action.payload.id] = action.payload;
    },
    setAllModals: (state, action: PayloadAction<boolean>) => {
      Object.entries(state.list).forEach(([_, entry]) => {
        entry.isVisible = action.payload;
      });
    },
  },
});

// ACTIONS
export const { setModalState, setAllModals } = modalSlice.actions;

// Selectors
//--------------

export const getModalStateList = createSelector(
  (state: RootState) => state.modal.list,
  (modals) => modals
);

export const getModalState = (id?: string) =>
  createSelector(getModalStateList, (modal) => {
    if (id && modal[id]) {
      return modal[id];
    }
    return { id: '', isVisible: false } as ModalObject;
  });

export default modalSlice.reducer;
